<template>
  <div>
    <a-space style="margin-bottom: 10px">
      <a-input-search v-model="formData.productKeyword" placeholder="输入产品名称/代码" @search="() => getList()" @pressEnter="() => getList()" />
      <!-- <line-select @setVal="changeForm" feild="lineId" :setFirst="true" /> -->
      <animal-list @setVal="changeForm" feild="animalTypeCode" :setFirst="true" :clearble="false" />
      <a-input-search v-model="formData.searchEbsKey" placeholder="输入EBS物料/编码" @search="() => getList()" @pressEnter="() => getList()" />
    </a-space>
    <a-table
      :columns="columns"
      :loading="ImportProductLibraryLoading"
      :data-source="list.records"
      :row-selection="{ selectedRowKeys, onChange: onSelectChange,getCheckboxProps }"
      row-key="id"
      :pagination="pagination"
      @change="listChange"
      :scroll="{y: 300,x:500}"
    >
    </a-table>
  </div>
</template>
<script>
import { nhfMixins } from "../../untils";
// import LineSelect from '@/components/Common/components/LineSelect.vue'
import AnimalList from '@/components/Common/components/AnimalList.vue'
import { getRequest } from "@/components/Common/Utils/Utils";
export default {
  mixins: [nhfMixins],
  components: {AnimalList},
  data(){
    return {
      columns: [
        {
          title: "产品名称",
          dataIndex: "productName",
          width: 100,
          ellipsis: true,
        },
        {
          title: "配方代码",
          dataIndex: "formulaCode",
          width: 160,
          ellipsis: true,
        },
        {
          title: "版本",
          dataIndex: "version",
          width: 80,
          ellipsis: true,
        },
        {
          title: "EBS物料",
          dataIndex: "ebsMaterial",
          width: 100,
          ellipsis: true,
        },
        {
          title: "EBS编码",
          dataIndex: "ebsMaterialCode",
          width: 100,
          ellipsis: true,
        },
        {
          title: "动物类型",
          dataIndex: "animalTypeName",
          width: 100,
          ellipsis: true,
        },
        {
          title: "工厂名称",
          dataIndex: "factoryName",
          width: 160,
          ellipsis: true,
        },
        {
          title: "营养师",
          dataIndex: "staffName",
          width: 100,
          ellipsis: true,
        },
      ],
      factoryId: window.localStorage.getItem('factoryId'),
      staffId: window.localStorage.getItem('staffId'),
      formData: {
        productKeyword: undefined,
        searchEbsKey: undefined,
      }
    }
  },
  watch: {
    selectedRows: {
      handler(val){
        this.$emit('selectLen',val.length)
      },
      deep: true,
    }
  },
  // mounted(){
  //   this.getList()
  // },
  methods: {
    changeForm(data){
      this.formData = {...this.formData,...data}
      this.getList()
    },
    listChange(page) {
      this.getList({ ...this.tablePageChange(page), ...this.filterData ,...this.search});
    },
    getList(arg = {}) {
      let {current=1,size=20} = arg || {}
      const data = {
        isActivate: 1,
        factoryId: this.factoryId,
        staffId: this.staffId,
        formulaId: getRequest('id'),
        query: {current,size},
        ...this.formData,
        ...arg,
      };
      this.ImportProductLibraryLoading = true
      this.fetchPost({
        actions: this.getNotInCustomProLibPageByCond,
        isList: true,
        data,
        name: "list",
        loading: "ImportProductLibraryLoading",
        showMessage: false
      });
    },
  }
}
</script>